var cookieConsent = cookieConsent || {}

cookieConsent.message = cookieConsent.message || 'We use cookie to improve your experience on our site. To find out more, read our privacy policy.'
cookieConsent.acceptStr = cookieConsent.acceptStr || 'Accept'
cookieConsent.refuseStr = cookieConsent.refuseStr || 'Refuse'
cookieConsent.closeStr = cookieConsent.closeStr || 'Close'

cookieConsent.accept = function () {
    const d = new Date();
    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000); //30 jours
    let expires = "expires=" + d.toUTCString();
    document.cookie = "cookie_consent=yes;" + expires + ";path=/";
    this.hideBar();
}

cookieConsent.refuse = function () {
    const d = new Date();
    d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000); //30 jours
    let expires = "expires=" + d.toUTCString();
    document.cookie = "cookie_consent=no;" + expires + ";path=/";
    this.hideBar();
}
cookieConsent.default = function () {
    document.cookie = "cookie_consent=undecided;path=/";
    this.hideBar();
}
cookieConsent.hideBar = function () {
    var element = document.getElementsByClassName('consent-bar');
    for (var i = 0; i < element.length; i++) {
        element[i].style.display = 'none';
    }
}
cookieConsent.get = function () {
    let decodedCookie = decodeURIComponent(document.cookie);

    cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf("cookie_consent" + "=") == 0) {
            return cookie.substring(("cookie_consent" + "=").length, cookie.length);
        }
    }
    return "";
}
cookieConsent.output = function () {
    if (!this.get()) {
        var myDiv = document.createElement('div')
        myDiv.className = 'consent-bar'
        myDiv.innerHTML = '<span class="message">' + this.message + '</span>'
                + '<div class="actions">'
                + '<a onclick="cookieConsent.accept()" id="accept-consent-action" class="button" href="javascript:;">' + this.acceptStr + '</a>'
                + '<a onclick="cookieConsent.refuse()" id="refuse-consent-action" class="button" href="javascript:;">' + this.refuseStr + '</a>'
                + '</div>'
                + '<a onclick="cookieConsent.default()" class="close-action" href="javascript:;"> <span class="screen-reader-text">' + this.closeStr + '</span></a>';
        document.body.appendChild(myDiv)
    }
}


document.addEventListener('DOMContentLoaded', function () {
    cookieConsent.output()
});